export const getHighlightedText = (text, searchText) => {
    const startIndex = text.toLowerCase().indexOf(searchText.toLowerCase());
    if (startIndex < 0) return null;
    return text.substring(startIndex, startIndex + searchText.length);
};
